export const renderApiDomain = () => {
  let isLink = typeof window !== "undefined" && window.location.origin;

  switch (isLink) {
    case "https://portal.iuxvn.com":
    case "https://portal.id-iux.com":
    case "https://portal.iuxvn-trading.com":
    case "https://portal.trade-iux.com":
      return process.env.REACT_APP_API_URL_V2;
    default:
      return process.env.REACT_APP_API_URL_V2_NEW;
  }
};

export const getApiUrlV2 = () => {
  let isLink = typeof window !== "undefined" && window.location.origin;

  switch (isLink) {
    case "https://portal.iuxvn.com":
    case "https://portal.id-iux.com":
    case "https://portal.iuxvn-trading.com":
    case "https://portal.trade-iux.com":
      return process.env.REACT_APP_API_URL_V2;
    default:
      return process.env.REACT_APP_API_URL_V2_NEW;
  }
};
